<template>
  <v-app light>
      <v-content class="pa-5">
      <v-form>
        <h1>Cadastro</h1>
        <v-text-field v-model="name" label="Nome" required ></v-text-field>
        <v-text-field v-model="email" label="E-mail" required ></v-text-field>
        <v-text-field v-model="password" label="Senha" required ></v-text-field>
        <v-btn @click="register()">Cadastrar</v-btn>
      </v-form>

			<v-alert :value="true" v-if="error" type="warning">
				{{ error }}
			</v-alert>

			<router-link tag="li" to="/">
				<a>/home</a>
			</router-link>
			<router-link tag="li" to="/login">
				<a>/login</a>
			</router-link>
			<router-link tag="li" to="/cadastro">
				<a>/cadastro</a>
			</router-link>
    </v-content>
  </v-app>
</template>

<script>
import { auth } from '../firebaseInit'

export default {
  name: 'Cadastro',
  data: () => ({
		name: null,
		email: null,
		password: null,
		error: null,
  }),
	methods: {
		register(){
			auth.createUserWithEmailAndPassword(this.email, this.password)
			.then(
				data => {
					data.user.updateProfile({
						displayName: this.name
					}).catch(function(err) {
						console.log(err)
					})
				},
				function(err) {
					console.log(err)
					switch(err.code){
						case 'auth/email-already-in-use':
							this.error = 'Email já cadastrado.'
							break;
						case 'auth/invalid-email':
							this.error = 'Email inválido.'
							break;
						case 'auth/operation-not-allowed':
							this.error = 'Operação não permitida.'
							break;
						case 'auth/weak-password':
							this.error = 'Senha muito fraca.'
							break;
						default:
							this.error = 'Não foi possível finalizar o cadastro, tente novamente mais tarde.'
					}
				}.bind(this)
			)
		},
	}
}
</script>